var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('badge',{attrs:{"type":_vm.getBadgeType()}},[_vm._v(" "+_vm._s(_vm.$t(`CASH_REGISTER_READINGS.STATUS_${_vm.cashRegisterReading.status}`))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }